/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

/**
 * Represents the type of a tadpole-to-tutor transaction.
 */
export enum TadpoleToTutorTransactionType {
  MEMBER_OF_PAYMENT_GROUP = "MEMBER_OF_PAYMENT_GROUP",
  AUTOMATIC_PAYMENT_FOR_A_GROUP_OF_MEETINGS = "AUTOMATIC_PAYMENT_FOR_A_GROUP_OF_MEETINGS",
  EXTERNAL_PAYMENT_FOR_A_GROUP_OF_MEETINGS = "EXTERNAL_PAYMENT_FOR_A_GROUP_OF_MEETINGS",
}
